import { Link } from 'react-router'
import { Stack } from '~/components-v2/stack/stack'

export const flashActive = false
export const fundraisingActive = false

export const FundraisingFlashContent = () => (
  <Stack row gap={3} align="center">
    <Link className="flash-banner-link" to="/blog/omni-series-c-funding">
      <span>Omni Raises Series C at a $1.5B Valuation</span>
      <img
        className="flash-link-icon"
        src="/images/flash-link-icon-next.svg"
        alt=""
        aria-hidden="true"
      />
    </Link>
  </Stack>
)

export const LennyFlashContent = () => (
  <Stack row gap={3} align="center">
    <img
      className="flash-icon"
      src="/images/omni-lennys-newsletter-blobby.webp"
      alt=""
      aria-hidden="true"
    />
    <strong>
      Welcome, Lenny&apos;s listeners! Get a free{' '}
      <Link className="flash-link" to="/demo">
        3-week trial
      </Link>
      .
    </strong>
  </Stack>
)

export const TwentyVentureCapitalFlashContent = () => (
  <Stack row gap={3} align="center">
    <strong>
      Welcome, 20VC listeners! Get a free{' '}
      <Link className="flash-link" to="/demo">
        3-week trial
      </Link>
      .
    </strong>
  </Stack>
)
